import { createFileRoute, redirect } from '@tanstack/react-router'
import { InviteMembersPage } from '@/features/onboarding/InviteMembersPage'

/**
 * A2/B2 — Invite members (formerly step 2 of the create-workspace flow).
 *
 * The step was removed from the create flow: create-workspace now lands the
 * user directly on the Home dashboard. This route stays as a compatibility
 * redirect for any bookmarked or emailed link — it forwards `?welcome=1` so
 * a first-time creator's A3 starter kit still fires on `/dashboard`.
 *
 * `InviteMembersPage` and `InviteMembersForm` are kept in the codebase as
 * reference; nothing renders them today. Delete `beforeLoad` and re-point
 * `CreateWorkspacePage` here to revive the step-2 UI.
 */
type InviteMembersSearch = {
  ws?: string
  welcome?: '1'
}

export const Route = createFileRoute('/_ws/invite-members')({
  validateSearch: (search: Record<string, unknown>): InviteMembersSearch => {
    const out: InviteMembersSearch = {}
    if (typeof search.ws === 'string' && search.ws.length > 0) out.ws = search.ws
    if (search.welcome === '1') out.welcome = '1'
    return out
  },
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard',
      search: search.welcome === '1' ? { welcome: '1' } : {},
    })
  },
  component: InviteMembersPage,
})
